import { useQuery } from "@tanstack/react-query";
import { getProducts } from "@/lib/api";

export default function useProducts() {
  return useQuery({ queryKey: ["products"], queryFn: getProducts, staleTime: 60_000 });
}
